export const CART_VALUE = 'cart_value';
